import React from 'react';
import './LoadingSpinner.css';

type LoadingSpinnerSize = 'sm' | 'md' | 'lg';

interface LoadingSpinnerProps {
  label?: string;
  size?: LoadingSpinnerSize;
  /** Center in a full viewport (or parent) panel */
  fullPage?: boolean;
  className?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  label,
  size = 'md',
  fullPage = false,
  className = '',
}) => {
  const classes = [
    'og-loading',
    `og-loading--${size}`,
    fullPage ? 'og-loading--full-page' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={classes} role="status" aria-live="polite" aria-busy="true">
      <div className="og-loading__visual" aria-hidden="true">
        <span className="og-loading__track" />
        <span className="og-loading__ring" />
        <span className="og-loading__dot" />
      </div>
      {label ? <p className="og-loading__label">{label}</p> : null}
      <span className="og-loading__sr-only">{label || 'Loading'}</span>
    </div>
  );
};

export default LoadingSpinner;
